/* ENGRAM · «Avisar-me quando voltar» na página de produto (ecrãs 1m-01 / 1m-02 / 1m-03). Marcação em snippets/engram-pdp-notify.liquid.
   Segue a variante escolhida (evento «engram:variant:change» de assets/engram-pdp.js e o «change» do seletor do tema):
   esgotada → mostra o bloco e põe engram-soldout-on no <html> (o CSS esconde o botão do tema, a dica e o prazo).
   O pedido é o mesmo do tema activo: POST à API cliente do Klaviyo, com o id da variante escolhida nesse momento.
   Sucesso = resposta ok ou 202; qualquer outra resposta, ou falha de rede, é erro (com nova tentativa).
   4 Nov 2026: a seguir ao back-in-stock, o email entra também na lista do Klaviyo de data-list (API cliente,
   subscriptions), sem bloquear: se essa segunda chamada falhar, o aviso da variante já ficou feito.
   A barra fixa (engram-pdp.js) pede o foco no campo com o evento «engram:notify:focus». */
(function () {
  if (window.__engramNotify) return;
  window.__engramNotify = true;

  var ENDPOINT = 'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=';
  var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    var root = document.querySelector('[data-engram-notify]');
    if (!root) return;
    var $ = function (sel) { return root.querySelector(sel); };
    var productCard = $('[data-engram-notify-product]');
    var variantBox = $('[data-engram-notify-variant]');
    var hint = $('[data-engram-notify-hint]');
    var choose = $('[data-engram-notify-choose]');
    var form = $('[data-engram-notify-form]');
    var email = $('[data-engram-notify-email]');
    var submit = $('[data-engram-notify-submit]');
    var message = $('[data-engram-notify-message]');
    var note = $('[data-engram-notify-note]');
    var sent = $('[data-engram-notify-sent]');
    var done = $('[data-engram-notify-done]');
    var doneText = $('[data-engram-notify-done-text]');
    var change = $('[data-engram-notify-change]');
    var productAvailable = root.getAttribute('data-product-available') === 'true';
    var title = root.getAttribute('data-product-title') || '';
    var attr = function (name) { return root.getAttribute(name) || ''; };

    var variantsCache = null;
    function variants() {
      if (variantsCache) return variantsCache;
      var el = document.querySelector('[data-engram-variant-prices]');
      try { variantsCache = el ? JSON.parse(el.textContent) : {}; } catch (e) { variantsCache = {}; }
      return variantsCache;
    }
    function currentId() {
      var productForm = document.querySelector('form[data-type="add-to-cart-form"]');
      var input = productForm && productForm.querySelector('[name="id"]');
      return input ? String(input.value) : '';
    }

    /* A opção que distingue a variante esgotada das que há: a primeira em que, mantendo as outras, existe um valor disponível.
       Ex.: Dourado / 15mm esgotado, Prateado / 15mm disponível → opção 0, valores [Prateado]. */
    function alternatives(id) {
      var all = variants(), cur = all[id];
      if (!cur || !cur.options) return null;
      for (var i = 0; i < cur.options.length; i++) {
        var values = [];
        Object.keys(all).forEach(function (key) {
          var v = all[key];
          if (!v.available || !v.options || v.options[i] === cur.options[i]) return;
          for (var j = 0; j < cur.options.length; j++) if (j !== i && v.options[j] !== cur.options[j]) return;
          if (values.indexOf(v.options[i]) === -1) values.push(v.options[i]);
        });
        if (values.length) return { index: i, value: cur.options[i], values: values };
      }
      return { index: 0, value: cur.options[0], values: [] };
    }

    function joinValues(values) {
      if (values.length < 2) return values.join('');
      return values.slice(0, -1).join(', ') + ' ' + attr('data-and') + ' ' + values[values.length - 1];
    }

    /* o seletor do tema: rádios (cores, pastilhas) ou lista */
    function optionControl(index, value) {
      var names = [];
      try { names = JSON.parse(attr('data-options')); } catch (e) {}
      var name = names[index];
      if (!name) return null;
      var radios = document.querySelectorAll('variant-selects input[type="radio"]');
      for (var r = 0; r < radios.length; r++) if (radios[r].name === name && (value === undefined || radios[r].value === value)) return radios[r];
      var selects = document.querySelectorAll('variant-selects select');
      for (var s = 0; s < selects.length; s++) if (selects[s].name === 'options[' + name + ']') return selects[s];
      return null;
    }

    /* «Cor · Dourado — esgotado» no rótulo da opção (o rótulo é do tema; a nota entra por aqui e sai quando volta a haver) */
    function markLabel(info, soldOut) {
      var control = soldOut && info ? optionControl(info.index) : null;
      var box = control && control.closest('.product-form__input');
      var label = box && box.querySelector('.form__label');
      var notes = document.querySelectorAll('.engram-notify__label-note');
      if (label && notes.length === 1 && notes[0].parentNode === label) return; /* já está: não mexer (o observador do seletor voltava a chamar) */
      Array.prototype.forEach.call(notes, function (n) { n.remove(); });
      if (!label) return;
      var span = document.createElement('span');
      span.className = 'engram-notify__label-note';
      span.textContent = ' ' + attr('data-sold-out-label');
      label.appendChild(span);
    }

    var sentFor = {};
    var state = { id: null, info: null };

    function setMessage(text, kind) {
      message.textContent = text || '';
      message.className = 'engram-notify__message' + (kind ? ' is-' + kind : '');
      if (kind === 'invalid') email.setAttribute('aria-invalid', 'true');
      else email.removeAttribute('aria-invalid');
    }

    function showSent(id) {
      var info = state.info;
      var text = info && productAvailable
        ? attr('data-sent-variant').replace('[p]', title).replace('[v]', info.value)
        : attr('data-sent-product').replace('[p]', title);
      doneText.textContent = text;
      form.hidden = true;
      sent.hidden = false;
    }

    function showForm() {
      sent.hidden = true;
      form.hidden = false;
      setMessage('');
      submit.disabled = false;
      submit.textContent = submit.getAttribute('data-label-current') || submit.getAttribute('data-label');
    }

    function sync() {
      var id = currentId();
      var data = variants()[id];
      if (!data) return;
      var soldOut = !data.available;
      document.documentElement.classList.toggle('engram-soldout-on', soldOut);
      document.documentElement.classList.toggle('engram-soldout-all', !productAvailable);
      root.hidden = !soldOut;
      var info = soldOut && productAvailable ? alternatives(id) : null;
      markLabel(info, soldOut && productAvailable);
      if (id === state.id) return;
      state.id = id;
      state.info = info;
      if (!soldOut) return;

      var variantMode = !!info;
      productCard.hidden = variantMode;
      variantBox.hidden = !(variantMode && info.values.length);
      note.hidden = !variantMode;
      if (variantMode && info.values.length) {
        hint.textContent = attr('data-variant-hint').replace('[v]', info.value).replace('[o]', joinValues(info.values)) + ' ';
        choose.textContent = attr('data-choose').replace('[v]', info.values[0]);
        choose.hidden = false;
        choose.onclick = function () {
          var control = optionControl(info.index, info.values[0]);
          if (!control) return;
          if (control.tagName === 'SELECT') {
            control.value = info.values[0];
            control.dispatchEvent(new Event('change', { bubbles: true }));
          } else control.click();
        };
      }
      submit.setAttribute('data-label-current', variantMode ? attr('data-button-variant').replace('[v]', info.value) : submit.getAttribute('data-label'));
      if (sentFor[id]) showSent(id);
      else showForm();
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var value = email.value.trim();
      if (!EMAIL.test(value)) {
        setMessage(message.getAttribute('data-invalid'), 'invalid');
        email.focus();
        return;
      }
      var id = state.id;
      setMessage('');
      submit.disabled = true;
      submit.textContent = submit.getAttribute('data-sending');
      var payload = {
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            profile: { data: { type: 'profile', attributes: { email: value } } },
            channels: ['EMAIL']
          },
          relationships: {
            variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + id } }
          }
        }
      };
      fetch(ENDPOINT + encodeURIComponent(attr('data-company')), {
        method: 'POST',
        headers: { accept: 'application/json', 'content-type': 'application/json', revision: '2024-06-15' },
        body: JSON.stringify(payload)
      })
        .then(function (response) {
          if (!(response.ok || response.status === 202)) throw new Error('klaviyo ' + response.status);
          sentFor[id] = value;
          var list = attr('data-list');
          if (list) {
            fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(attr('data-company')), {
              method: 'POST',
              headers: { accept: 'application/json', 'content-type': 'application/json', revision: '2024-06-15' },
              body: JSON.stringify({ data: { type: 'subscription', attributes: { custom_source: 'Engram · Avisar-me (esgotado)', profile: { data: { type: 'profile', attributes: { email: value } } } }, relationships: { list: { data: { type: 'list', id: list } } } } })
            }).catch(function () {});
          }
          if (state.id !== id) return; /* a cliente mudou de variante entretanto: o pedido ficou feito na de antes */
          showSent(id);
          done.focus();
        })
        .catch(function () {
          submit.disabled = false;
          submit.textContent = submit.getAttribute('data-retry');
          setMessage(message.getAttribute('data-error'), 'error');
        });
    });

    email.addEventListener('input', function () {
      if (message.classList.contains('is-invalid') && EMAIL.test(email.value.trim())) setMessage('');
    });

    change.addEventListener('click', function () {
      delete sentFor[state.id];
      showForm();
      email.focus();
      email.select();
    });

    document.addEventListener('engram:notify:focus', function () {
      if (root.hidden) return;
      var target = sent.hidden ? email : done;
      root.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
      target.focus({ preventScroll: true });
    });

    document.addEventListener('engram:variant:change', sync);
    /* o tema volta a desenhar o seletor depois da troca (e leva a nota «— esgotado»): repõe-se */
    var picker = document.querySelector('variant-selects');
    if (picker) {
      var again;
      new MutationObserver(function () { clearTimeout(again); again = setTimeout(function () { markLabel(state.info, !root.hidden && productAvailable); }, 50); })
        .observe(picker, { childList: true, subtree: true });
    }
    document.addEventListener('change', function (event) {
      if (event.target.closest && event.target.closest('variant-selects, variant-radios, .product-form__input')) {
        setTimeout(sync, 0);
        setTimeout(sync, 600);
      }
    });
    sync();
  });
})();
